import { gql } from 'apollo-boost'
import { UsersDataSourceFragment } from '../fragments'

const mutation = gql`
  mutation ClearSyncAccounts {
    clearSyncAccounts(origin: mobile) {
      success
      query {
        currentUser {
          id
          ...UsersDataSource
        }
      }
      errors {
        key
        message
      }
    }
  }
  ${UsersDataSourceFragment}
`

export default mutation
